IpRegionLimitManager = xClass("IpRegionLimitManager");

IpActivityType = {
    addstap_share: 1 //关末分享活动
}
IpLimitType = {
    normal:0,
    ip:1,
    link:2
    //search:3,
    //scan:4
}

var instance = null
IpRegionLimitManager.getInstance = function () {
    if (!instance) {
        instance = IpRegionLimitManager.new()
    }
    return instance
}

IpRegionLimitManager.prototype.ctor = function () {
    var self = this
    self.limitSceneList = {}//{number:{string:[]}}
    self.limitPlatformList = {}//{string:bool}
    self.tmpLimitStatusList = {}
    self.inited = false
}

IpRegionLimitManager.prototype.parseLimitScene = function (data, activityType){
    var self = this
    //读取活动限制强度配置'platformID:status1:status2:status3;platformID:activityId:status1'
    cc.log("----parseLimitScene----")
    cc.log(data, activityType)
    if (data) {
        let cfgList = data.split(';')
        cc.log("cfgList", cfgList)
        let activityList = []
        let activityLen = 0
        self.limitSceneList[activityType] = {}
        for (let i = 0; i < cfgList.length; i++) {
            activityList = cfgList[i].split(':')
            activityLen = activityList.length
            if (activityLen == 2){
                let platform = activityList[0]
                let limitList = activityList[1].split(',')
                self.limitPlatformList[platform] = true
                self.limitSceneList[activityType][platform] = []
                for (let j = 0; j < limitList.length; ++j){
                    self.limitSceneList[activityType][platform].push(limitList[j])
                }
            }
        }
        cc.log("self.limitSceneList", self.limitSceneList)
    }
}

IpRegionLimitManager.prototype.init = function (){
    var self = this
    
    console.log("@@@@run ip regionlimit init")
    if (self.inited){
        return Promise.resolve()
    }

    self.inited = true
    //TODO:读取配置 现在是分开每个活动单独配置 看情况合起来
    return CfgManager.load("game").then((dataMap)=>{
        console.log("@@@@load game.json success")
        let gameCfg = dataMap.get('game')
        self.parseLimitScene(gameCfg.addstap_share_promote_blacklist_mode, IpActivityType.addstap_share)
        CfgManager.release("game")
    })
}

/**
 * 检查进入游戏状态
 */
IpRegionLimitManager.prototype.checkEnterStatus = function(data){
    let self = this

    if (self.enterStatusChecked)
        return
    
    self.enterStatusChecked = true
    //屏蔽搜索进入,只检测配置里存在的场景
    console.log("@@@@run check status")
    let platform = "wanba_ts"
    if (window.mini){
        platform = mini.getPlatform()
    }

    if (self.limitPlatformList[platform]){
        //链接屏蔽
        if (data.ipRegionLimit){
            let decodeData = decodeURIComponent(data.ipRegionLimit)
            console.log("@@@@run link:"+decodeData)
            let limitData = JSON.parse(decodeData)
            if (limitData){
                console.log("@@@@parse link ipregionlimit success len:"+limitData.length)
            }else{
                console.log("@@@@parse link ipregionlimit failed:"+(data.ipRegionLimit))
            }

            let len = limitData.length
            for (let i = 0; i < len; ++i){
                if (limitData[i] && limitData[i].status){
                    let len = limitData[i].status.length
                    for (let j = 0; j < len; ++j){
                        if (limitData[i].status[j] == IpLimitType.ip){
                            self.tmpLimitStatusList[limitData[i].funId] = IpLimitType.link
                            break;
                        }
                    }

                }
            }
        }else{
            //其它屏蔽
            if (window.mini){
                let enterScene = mini.getLaunchOptionsSync().scene
                console.log("@@@@enter scene:"+enterScene)
                //if (enterScene == 1005 || enterScene == 1006 || enterScene == 1042){
                for (let k in self.limitSceneList){
                    if (self.limitSceneList[k][platform]){
                        let len = self.limitSceneList[k][platform].length
                        for (let i = 0; i < len; ++i){
                            if (self.limitSceneList[k][platform][i] == enterScene){
                                self.tmpLimitStatusList[k] = enterScene
                                break;
                            }
                        }
                    }
                }
            }else{
                //TODO:wanba
            }
        }
        
        console.log("@@@@tmp limit statusList:"+JSON.stringify(self.tmpLimitStatusList))
    }
    self.getRegionStatus();
}

/**
 * 检测屏蔽状态
 */
IpRegionLimitManager.prototype.getRegionStatus = function(dcCb = null){
    console.log("@@@@run getRegionStatus")
    let self = this
    let platform = "wanba_ts"
    if (window.mini){
        platform = mini.getPlatform()
    }
    //获取ip屏蔽信息(获取的时候后端才过滤,所以只要是0就会获取一次)
    if (self.limitPlatformList[platform]){
            {
                function onIpSuccess(evt) {
                    console.log("@@@@get ip region limit success:"+JSON.stringify(evt))
                    let curLimit = evt.data.status
                    let needUpdataStatus
                    for (let k in self.tmpLimitStatusList){
                        if (self.tmpLimitStatusList[k]){
                            cc.log("curLimit", curLimit)
                            if (curLimit.length == 1 && curLimit[0] == null){
                                if (!needUpdataStatus){
                                    needUpdataStatus = []
                                }
                                needUpdataStatus.push({funId:k, status:self.tmpLimitStatusList[k]})
                                break
                            }
                            for (let i = 0; i < curLimit.length; ++i){
                                if (curLimit[i] && curLimit[i].funId == k){
                                    let serverActiveStatus = curLimit[i].status
                                    cc.log("serverActiveStatus", serverActiveStatus)
                                    if (serverActiveStatus){
                                        let len = serverActiveStatus.length
                                        let index = 0
                                        for (; index < len; ++index){
                                            cc.log("------", serverActiveStatus[index], self.tmpLimitStatusList[k]);
                                            if (serverActiveStatus[index] == self.tmpLimitStatusList[k])
                                                break
                                        }
                                        if (index == len && index != 0){
                                            //curLimit[k].push(self.tmpLimitStatusList[k])
                                            if (!needUpdataStatus){
                                                needUpdataStatus = []
                                            }
                                            needUpdataStatus.push({funId:k, status:self.tmpLimitStatusList[k]})
                                        }
                                    }else{
                                        //curLimit[k] = []
                                        //curLimit[k].push(self.tmpLimitStatusList[k])
                                        if (!needUpdataStatus){
                                            needUpdataStatus = []
                                        }
                                        needUpdataStatus.push({funId:k, status:self.tmpLimitStatusList[k]})
                                    }

                                }
                            }
                        }
                    }
                    if (needUpdataStatus){
                        console.log("@@@@needupdata status:"+JSON.stringify(needUpdataStatus))
                        var http = SaveIpRegionStatusHttp.new()
                        http.addEventListener(Events.kComplete, (evt)=>{
                            console.log("@@@@save ip region limit success："+JSON.stringify(evt.data.status))
                            UserManager.getInstance().getUserExtendRef().ipRegionLimit = evt.data.status
                            self.checkWhiteList();
                            self.enterStatusChecked = false
                        })
                        http.addEventListener(Events.kError, ()=>{console.log("@@@@save ip region limit failed")})
                        http.addEventListener(Events.kCancel, ()=>{console.log("@@@@save ip region limit failed")})
                        http.load({status:needUpdataStatus})
                    }else{
                        UserManager.getInstance().getUserExtendRef().ipRegionLimit = evt.data.status
                        self.checkWhiteList();
                        self.enterStatusChecked = false
                    }
                    if (dcCb){
                        dcCb();
                    }
                }
                function onIpError(evt) {
                    console.log("@@@@get ip region limit failed:"+JSON.stringify(evt))
                }
                var http = IpRegionStatusHttp.new()
                http.addEventListener(Events.kComplete, onIpSuccess)
                http.addEventListener(Events.kError, onIpError)
                http.addEventListener(Events.kCancel, onIpError)
                http.load()
            }
        }
}

IpRegionLimitManager.prototype.checkWhiteList = function(){
    CfgManager.load("wx_group_share").then((dataMap)=>{
        let wxShareCfg = dataMap.get('wx_group_share')
        var whiteList = wxShareCfg.addstap_share_promote_whitelist_id;
        cc.log("whiteList", whiteList);
        var uid = UserManager.getInstance().uid;
        for(var i in whiteList){
            if (uid == whiteList[i]){
                UserManager.getInstance().getUserExtendRef().ipRegionLimit = {};
            }
        }
        CfgManager.release("wx_group_share")
    })
}